import React, { useState } from 'react';
import { api } from '../services/api';

interface LoginProps {
  onLoginSuccess: (token: string, user: any) => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess }) => {
  const [loginType, setLoginType] = useState<'email' | 'phone'>('email');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [isRegistering, setIsRegistering] = useState(false);
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (loginType === 'email' && !email) {
      setError("Email est requis");
      setLoading(false);
      return;
    }
    if (loginType === 'phone' && !phone) {
      setError("Téléphone est requis");
      setLoading(false);
      return;
    }

    try {
      const loginData = {
        identifier: loginType === 'email' ? email : '+221' + phone,
        password: password,
        login_type: loginType
      };

      if (isRegistering) {
        const registerData: any = {
          name: name,
          password: password
        };
        
        // Ajouter email ou phone selon le type de connexion
        if (loginType === 'email') {
          registerData.email = email;
        } else {
          registerData.phone = '+221' + phone; // Ajouter l'indicatif
        }
        
        const response = await api.post('/auth/register', registerData);
        onLoginSuccess(response.data.access_token, response.data.user);
      } 
      else {
        const response = await api.post('/auth/login', loginData);
        onLoginSuccess(response.data.access_token, response.data.user);
      }
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>🏪 Gestion de Boutique</h1>
          <h2>{isRegistering ? 'Créer un compte' : 'Connexion'}</h2>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {isRegistering && (
            <div className="form-group">
              <label htmlFor="name">Nom complet *</label>
              <input
                id="name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Votre nom"
                required
              />
            </div>
          )}

          <div className="form-group">
            <label>Type d'identifiant</label>
            <div className="radio-group">
              <label className={`radio-card ${loginType === 'email' ? 'active' : ''}`}>
                <input
                  type="radio"
                  value="email"
                  checked={loginType === 'email'}
                  onChange={() => setLoginType('email')}
                />
                <span className="radio-icon">📧</span>
                <span className="radio-text">Email</span>
              </label>
              <label className={`radio-card ${loginType === 'phone' ? 'active' : ''}`}>
                <input
                  type="radio"
                  value="phone"
                  checked={loginType === 'phone'}
                  onChange={() => setLoginType('phone')}
                />
                <span className="radio-icon">📱</span>
                <span className="radio-text">Téléphone</span>
              </label>
            </div>
          </div>

          {loginType === 'email' ? (
            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="exemple@email.com"
              />
            </div>
          ) : (
            <div className="form-group">
              <label htmlFor="phone">Téléphone *</label>
              <div className="input-group">
                <span className="input-addon">+221</span>
                <input
                  id="phone"
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="XX XXX XX XX"
                />
              </div>
            </div>
          )}

          <div className="form-group">
            <label htmlFor="password">Mot de passe *</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              minLength={6}
            />
          </div>

          {error && (
            <div className="error-message">
              ⚠️ {error}
            </div>
          )}

          <button 
            type="submit" 
            className="btn-primary btn-full"
            disabled={loading}
          >
            {(() => {
              if (loading) return 'Chargement...';
              if (isRegistering) return 'Créer le compte';
              return 'Se connecter';
            })()}
          </button>

          {/* <div className="login-footer">
            <button
              type="button"
              className="link-button"
              onClick={() => {
                setIsRegistering(!isRegistering);
                setError('');
              }}
            >
              {isRegistering 
                ? 'Vous avez déjà un compte ? Se connecter' 
                : 'Pas de compte ? Créer un compte'}
            </button>
          </div> */}
        </form>
      </div>
    </div>
  );
};

export default Login;
